import Vue from 'vue'
import Router from 'vue-router'

import SignIn from '@/views/SignIn'
import SignUp from '@/views/SignUp'
import ResetPassword from '@/views/ResetPassword'
import SchoolList from '@/views/SchoolList'
import NurseList from '@/views/NurseList'
import ChildDetail from '@/views/ChildDetail'
import ChildNote from '@/views/ChildNote'
import ChildList from '@/views/ChildList'
import ManagerList from '@/views/ManagerList'
import Maintenance from '@/views/Maintenance'
import Message from '@/views/Message'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', redirect: { name: 'SignIn' }},
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/school',
      name: 'SchoolList',
      component: SchoolList
    },
    {
      path: '/nurse/:nurseryCode/:nurseryName',
      name: 'NurseList',
      component: NurseList
    },
    {
      path: '/child/:nurseryCode/:nurseryName',
      name: 'ChildList',
      component: ChildList
    },
    {
      path: '/child/detail/:nurseryCode/:nurseryName/:childId',
      name: 'ChildDetail',
      component: ChildDetail
    },
    {
      path: '/child/note/:nurseryCode/:nurseryName/:childId/:childName',
      name: 'ChildNote',
      component: ChildNote
    },
    {
      path: '/manager',
      name: 'ManagerList',
      component: ManagerList
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/message',
      name: 'Message',
      component: Message
    },
    {
      path: '*',
      redirect: '/signin'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js